
















import { Vue, Component } from 'vue-property-decorator';
import AList from './a-list.vue';
@Component({
  components: { AList }
})
export default class Unit4 extends Vue {
  bread = [{ name: '板块部门指标运营驾驶仓' }, { name: '运营板块' }];

}
